import { useMemo } from "react";
import { useLocation } from "react-router-dom";

function useQueryParams() {
  const location = useLocation();

  const queryParams = useMemo(() => {
    return new URLSearchParams(location.search);
  }, [location.search]);

  return queryParams;
}

export function useWindowQueryParams() {
  return new URLSearchParams(window.location.search);
}

export default useQueryParams;
